import { Outlet, useLocation } from 'react-router-dom'
import { useLoading } from 'stores'
import classNames from 'classnames'
import { Loading } from '../Loading'
import { Footer, Header } from 'components/organisms'
import { ROUTE_HOME, ROUTE_STORE_DETAIL } from 'constant'

export const Layout = () => {
  const { pathname, search } = useLocation()
  const isLoading = useLoading(state => state.isLoading)

  return (
    <div className="w-full min-h-[100dvh] bg-gradation02">
      <div
        className={classNames({
          'flex flex-col w-full h-full items-center': true,
        })}
      >
        <div
          className={classNames(
            'flex flex-col sm:max-w-[375px] w-full  h-full bg-gradation01',
            {
              hidden:
                isLoading ||
                ([ROUTE_HOME, ROUTE_STORE_DETAIL].includes(pathname) &&
                  search === ''),
            },
          )}
        >
          <Header />
          <div className="flex-1 overflow-x-hidden overflow-y-auto min-h-0">
            <Outlet />
          </div>
          <Footer />
        </div>
        <div
          className={classNames(
            'flex flex-col sm:max-w-[375px] w-full  h-full bg-gradation01',
            {
              hidden:
                [ROUTE_HOME, ROUTE_STORE_DETAIL].includes(pathname) &&
                search !== '',
            },
          )}
        >
          <Outlet />
        </div>
      </div>
      <Loading />
    </div>
  )
}
